import React, { Component } from 'react'
import {
  PageIconWrapper,
  PageNumberWrapper,
  Pages,
  PagesPagination
} from './syles'
import PaginationRightArrow from '../../icons/PaginationRightArrow'
import PaginationLeftArrow from '../../icons/PaginationLeftArrow'

interface PaginationProps {
  onPageChanged?: any
  actualPage?: number
  actualPages?: number[]
  allPages?: any[]
}
interface State {
  actualPage: number
  actualPages: number[]
}

class Pagination extends Component<PaginationProps, State> {
  constructor(props: State) {
    super(props)

    this.state = {
      actualPage: 0,
      actualPages: [0, 1, 2, 3]
    }
  }

  incrementPage = (actualPages: any[]) => {
    const { onPageChanged, allPages = [] } = this.props
    const { actualPage } = this.state
    let page = actualPage
    const increment = ++page
    if (increment > allPages.length - 1) {
      return
    }
    this.setState({ actualPage: increment, actualPages })
    return onPageChanged(increment)
  }

  decrementPage = (actualPages: any[]) => {
    const { onPageChanged } = this.props
    const { actualPage } = this.state
    let page = actualPage
    const decrement = --page
    if (decrement < 0) {
      return
    }
    this.setState({ actualPage: decrement, actualPages })
    return onPageChanged(decrement)
  }

  onPageChanged = (page: number, actualPages: any[]) => {
    const { onPageChanged } = this.props
    onPageChanged(page)
    this.setState({ actualPage: page, actualPages })
  }

  getViewPageNumbers(allPages: any[]) {
    const { actualPage, actualPages } = this.state
    allPages = allPages.map(i => Number(i))
    const newActualPage = allPages.slice(0, 4)
    if (allPages.length > 4) {
      const length = allPages.length - 1
      if (actualPage === length) {
        return [actualPage - 3, actualPage - 2, actualPage - 1, actualPage]
      } else if (
        actualPage < length &&
        actualPage > Number(newActualPage[2]) &&
        actualPage > Number(actualPages[1])
      ) {
        return [actualPage - 2, actualPage - 1, actualPage, actualPage + 1]
      } else if (
        actualPage < length &&
        actualPage !== Number(newActualPage[0]) &&
        actualPage < Number(actualPages[2])
      ) {
        return [actualPage - 1, actualPage, actualPage + 1, actualPage + 2]
      } else if (actualPage < Number(newActualPage[1])) {
        return [actualPage, actualPage + 1, actualPage + 2, actualPage + 3]
      }
    } else {
      return newActualPage
    }
    return newActualPage
  }

  render() {
    const { allPages = [] } = this.props
    const { actualPage } = this.state
    const viewPages = this.getViewPageNumbers(allPages)
    return (
      <PagesPagination>
        <PageIconWrapper onClick={() => this.decrementPage(viewPages)}>
          <PaginationLeftArrow />
        </PageIconWrapper>
        <Pages>
          {viewPages.map(i => (
            <PageNumberWrapper
              key={i}
              // tslint:disable-next-line:jsx-no-lambda
              onClick={() => this.onPageChanged(Number(i), viewPages)}
              isActive={Number(i) === Number(actualPage)}
            >
              <label>{Number(i) + 1}</label>
            </PageNumberWrapper>
          ))}
        </Pages>
        <PageIconWrapper onClick={() => this.incrementPage(viewPages)}>
          <PaginationRightArrow />
        </PageIconWrapper>
      </PagesPagination>
    )
  }
}

export default Pagination
